import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
import { WebApiService } from '../service/web-api.service';

@Injectable()
export class AuthService {

  /** V2かどうかのフラグ */
  private _isV2: boolean;

  constructor(private webApiServece: WebApiService) { }

  /**
   * 認可サーバとのセッション状態を確認します.
   */
  isRequested(screenId: string): Observable<boolean> {
    const requestParam = { auth_type: 'auth' , 'screen_id' : screenId};
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/auth-requested', requestParam)
      .map(cfResponse => {
        if (cfResponse.status === 200) {
          this._isV2 = cfResponse.data.isV2;
          return cfResponse.data.result;
        }
        return false;
      });
  }

  /**
 * V2かどうかのフラグを取得します.
 *
 * @return V2かどうかのフラグ
 */
  get isV2() {
    return this._isV2;
  }
}
